import React from 'react'

const PythonProwess = () => {
  return (
    <div>PythonProwess</div>
  )
}

export default PythonProwess